module.exports = __webpack_public_path__ + "static/img/impos.8be8286.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/impos.svg
// module id = tb7o
// module chunks = 1